import ManageGoalItems from './ManageGoalItems';
import { useSelector } from 'react-redux';

const ManageGoal = () => {
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);

     return (
          <>
               <div className='listener-title headline-wrapper'>
                    <h1>Goals</h1>
                    <div className='description'>
                         Manage the types of goals you want to use inside your account. Goals allow you to define rules for important action, characteristics, and KPIs
                         you care about.
                    </div>
               </div>

               {activeAccount.id && <ManageGoalItems />}
          </>
     );
};

export default ManageGoal;
